import React from 'react';
import BasicItemListView from '../../BasicItemListView';
import { SpriteFrame } from 'components/editor';
import styles from './LocationView.module.scss';

const LocationView = location => {
  const getPicture = () => {
    return <SpriteFrame
      frameNumber={location.previewFrame}
      size='xxs'
      className={styles.image}
    />;
  };

  return (
    <BasicItemListView
      name={location.name}
      pictureComponent={getPicture()}
      shotsCount={location.shotsCount}
      timeIntervals={location.intervals}
    />
  );
};

export default LocationView;
